import { render } from "./ShareWaModel.vue?vue&type=template&id=1942d6d1&scoped=true"
import script from "./ShareWaModel.vue?vue&type=script&lang=js"
export * from "./ShareWaModel.vue?vue&type=script&lang=js"

import "./ShareWaModel.vue?vue&type=style&index=0&id=1942d6d1&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1942d6d1"]])

export default __exports__